export const FILTER_OPTIONS = ["7d", "All", "Custom"];
export const BG_COLOR_ACTIVE = "#FFFFFF";
export const BG_COLOR_DEACTIVE = "#F7FAFE";

export const TEXT_COLOR_ACTIVE = "#367f98";
export const TEXT_COLOR_DEACTIVE = "#94a2b3";
export const DEFAULT_FILTER_OPTION = "All";
export const CUSTOM_FILTER_OPTION = "Custom";

export const PAGES_SIZE = [
  { key: "10", value: 10 },
  { key: "20", value: 20 },
  { key: "50", value: 50 },
  { key: "100", value: 100 },
];

export const SELECT_ACTION_OPTIONS = [
  { id: "duplicate", name: "Mark as duplicate" },
  { id: "valid", name: "Set  as Valid" },
  { id: "invalid", name: "Set as Invalid" },
  { id: "escalation", name: "Escalate" },
];

export const SHOW_USER_OPTIONS = [
  {
    value: 0,
    label: "Show",
  },
  {
    value: 1,
    label: "Hide",
  },
  {
    value: 2,
    label: "Hide from shared users",
  },
];

export const WHITELISTED_ACCOUNTS = [
  "daniel@flavorwiki.com",
  "zeeshan@flavorwiki.com",
  "zeeshan@gigalabs.co",
  "zeeshan@codebricks.co",
  "wasay@flavorwiki.com",
  "zain@flavorwiki.com",
  "fernanda@flavorwiki.com",
  "kenny@flavorwiki.com",
  "dilawar@flavorwiki.com",
  "ahmad@flavorwiki.com",
  "elli@flavorwiki.com",
  "tech-team@flavorwiki.com",
  "eleni@flavorwiki.com",
  "john.miller@flavorwiki.com",
  "muhammad.bilal@flavorwiki.com",
];

export const SYNC_ALLOWED_EMAILS = [
  "tech-team@flavorwiki.com",
  "zain@flavorwiki.com",
  "dilawar@flavorwiki.com",
  "wasay@flavorwiki.com",
];
